$(function() {
    // projects
    var form     = $('body.projects #projects-form');
    var select   = form.find('select');
    var category = form.find('.category');
    var input    = form.find('input');

    var projectSubmit = function(e){
        if (e) {
            e.preventDefault();
        }

        var projectsUrl = '/projects';
        var categoryValue = category.val();
        var keywordsValue = input.val();

        if (categoryValue) {
            projectsUrl += '/' + categoryValue;
        }
        if (keywordsValue) {
            projectsUrl += '?' + input.serialize();
        }

        var results = $('div.projects-wrapper');

        results.css('opacity', 0.3);

        if (window.history.replaceState) {
            window.history.replaceState(
                {}, document.title, projectsUrl
            );
        }

        results.load(projectsUrl + ' div.projects-wrapper>*', function(){
            results.css('opacity', 1);
        });
    };

    // Prevent the enter key from reloading the page
    form.submit(function(e) {
        e.preventDefault();
    });

    select.on('change', function(e) {
        projectSubmit(e);
    });

    var keyupTimeout;
    input.keyup(function(e) {
        clearTimeout(keyupTimeout);
        keyupTimeout = setTimeout(function() {
            projectSubmit(e);
        }, 500);
    });
});